// GET /sparks/transactions is a personal-wallet statement. The API does not
// expose project identity here; do not infer it from internal descriptions.
import { apiRequest } from '../../api/client'
import { isApiRecord, type ApiValue } from '../../api/responseDecoders'

export interface CreditMovement {
  id: string
  type: string
  credits: number
  balanceAfter: number
  createdAt: string
}

export function decodeCreditHistory(payload: ApiValue): CreditMovement[] {
  if (!isApiRecord(payload) || !Array.isArray(payload.transactions)) {
    throw new Error('credit history: expected transactions array')
  }
  return payload.transactions.map((row, index) => {
    if (!isApiRecord(row) || typeof row.id !== 'string' || !row.id ||
      typeof row.type !== 'string' || !row.type ||
      typeof row.sparks !== 'number' || !Number.isSafeInteger(row.sparks) ||
      typeof row.balance_after !== 'number' || !Number.isSafeInteger(row.balance_after) ||
      typeof row.created_at !== 'string' || !Number.isFinite(Date.parse(row.created_at))) {
      throw new Error(`credit history row ${index}: invalid statement fields`)
    }
    return { id: row.id, type: row.type, credits: row.sparks, balanceAfter: row.balance_after, createdAt: row.created_at }
  })
}

export async function readCreditHistory(signal?: AbortSignal): Promise<CreditMovement[]> {
  return decodeCreditHistory(await apiRequest<ApiValue>('/sparks/transactions?limit=20', { signal }))
}
